<template>
  <div>
    <h2>新闻列表</h2>
    <el-table :data="newsList" style="width: 100%">
      <el-table-column prop="title" label="标题" />
      <el-table-column prop="publishDate" label="发布时间" />
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="viewDetail(scope.row.id)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getNewsList } from '@/api/cms'

export default {
  data() {
    return {
      newsList: []
    }
  },
  created() {
    this.fetchNews()
  },
  methods: {
    fetchNews() {
      getNewsList().then(res => {
        this.newsList = res.data || []
      })
    },
    viewDetail(id) {
      this.$router.push({ name: 'NewsDetail', params: { id } })
    }
  }
}
</script>